<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3 mt-6 class="transparent-bg">
        <h1 class="text-center" style="color:#8B857D;">
          Dziękujemy za rejestrację
        </h1>
        <blockquote class="blockquote text-center" style="color:#8B857D;">
          Aby dokończyć proces aktywacji konta, kliknij w link aktywacyjny
          przesłany na podany przez Ciebie e-mail.
        </blockquote>
        <div class="" style="display: flex;align-items: center;justify-content: center; padding-bottom: 20px; padding-top: 20px;">
          <div @click="redirect" class="primary-button">Zaloguj się</div>
        </div>
        <!-- <blockquote class="blockquote text-center">
          <a class="center" @click="redirect">
            <div class="btn-gradient">Zaloguj się</div>
          </a>
        </blockquote> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  metaInfo: {
    title: "Dagajoga rejestracja - portal jogi online",
  },
  methods: {
    redirect() {
      this.$router.push({
        name: "Auth",
        params: { previousPage: "UserAccount" },
      });
    },
  },
};
</script>

<style scoped>
.transparent-bg {
  background-color: #d9d9d9;
  color: #54514c;
  border-radius: 32px;
  position: relative;
  padding: 40px;
  width: 100%;
  box-shadow: 0px 0px 100px 25px #b6afa5;
}
i {
  font-size: 120px;
}

.btn-gradient {
  width: fit-content;
  padding: 15px 25px;
  border-radius: 30px;
  font-size: 1.4rem;
}
.center {
  display: flex;
  justify-content: center;
  margin-right: 20px;
  margin-top: 15px;
}
a {
  text-decoration: none;
}
</style>
